// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-043d4156]{font-size:.875em;font-style:normal;font-weight:500;text-align:right}i[data-v-043d4156],span[data-v-043d4156]{color:#1e3966}.active[data-v-043d4156]{border-radius:5px;height:36px;padding:8px 4px}.active.on[data-v-043d4156],.active[data-v-043d4156]:hover{background-color:#e2f6ff!important}.active.on *[data-v-043d4156],.active:hover *[data-v-043d4156]{color:#0079b5!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
